import { render, staticRenderFns } from "./ProvidersView.vue?vue&type=template&id=34653c48&scoped=true&"
import script from "./ProvidersView.vue?vue&type=script&lang=js&"
export * from "./ProvidersView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34653c48",
  null
  
)

export default component.exports